import React from 'react';
import { RouteComponentProps } from '@reach/router';

const Dummy: React.FC<RouteComponentProps> = ({ location }) => {
    return <div></div>;
};

export { Dummy };
